import * as React from "react";
import {ActionButton} from "components/Button";
import {ActionButtonType} from "components/Button/ActionButton";
import Dialog, {DialogSize} from "components/Dialog/Dialog";
import styles = require("./style.less");
import DialogTrigger from "./DialogTrigger";

interface RenderDialogProps {
    open: boolean;
    sequence: string;
    closeDialog(): void;
    openDialog(): void;
}
interface OpenDialogButtonProps {
    label: any;
    disabled?: boolean | Promise<any>;
    icon?: JSX.Element;
    type?: ActionButtonType;
    dialogWidth?: DialogSize;
    renderDialog?: (props: RenderDialogProps) => React.ReactElement<any>;
    children?: React.ReactNode;
}

class OpenDialogButton extends React.Component<OpenDialogButtonProps, never> {

    constructor(props: OpenDialogButtonProps) {
        super(props);
    }

    render() {

        return <DialogTrigger render={({ open, openDialog, sequence, closeDialog }) => (
            <div className={styles.buttonDialogContainer}>
                <ActionButton
                    type={this.props.type}
                    icon={this.props.icon}
                    label={this.props.label}
                    disabled={this.props.disabled}
                    onClick={openDialog}
                />
                { this.props.renderDialog ? this.props.renderDialog({open, openDialog, sequence, closeDialog}) :
                    <Dialog open={open} dialogWidth={this.props.dialogWidth}>
                        {this.props.children}
                    </Dialog>}
            </div>
        )}/>;
    }
}

export default OpenDialogButton;